module.exports = __webpack_public_path__ + "img/logo.72443d2c.svg";